export default "__VITE_ASSET__CP9DTh4T__"